import { useState, useEffect } from 'react';

import bffClient from 'services/api/bff';

import useAuth from './useAuth';

export const useCategoryData = (initialData, slug) => {
  const [categoryData, setCategoryData] = useState(initialData);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();
  const shippingCountryCode = user?.shippingCountry;

  useEffect(() => {
    const fetchCategoryData = async () => {
      setIsLoading(true);
      try {
        const categoryEndpoint = `/categories/${slug}${
          shippingCountryCode ? `?shippingCountryCode=${shippingCountryCode}` : ''
        }`;

        const response = await bffClient.get(categoryEndpoint);
        const breadcrumbs = [];
        if (response?.data) {
          if (response?.data?.parent.categoryId) {
            breadcrumbs.push({ name: 'Creoate', slug: '/', type: 'homepage' });
          }
          breadcrumbs.push({ name: response?.data.name, slug: response?.data.slug, type: 'category' });
        }

        setCategoryData({
          categoryData: response?.data,
          initialBreadcrumbs: breadcrumbs,
        });
      } catch (error) {
        console.error('Error fetching category data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    // Always fetch when slug changes
    if (slug) {
      fetchCategoryData();
    }
  }, [slug]);

  return { categoryData, isLoading };
};
